import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@material-ui/core";
import { i18n, TFunction } from "i18next";
import { ApiStateType } from "customHooks/useApi";
import useValuesFromSource from "customHooks/useValuesFromSource";
import FormModal from "customHooks/useCompleoReactHookForm/components/FormModal";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { ModalDataType } from "./helperJobApprovalWorkflow";
import { Grid } from "@material-ui/core";
import * as util from "functions/util";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import { useRhfFieldWithoutControllerOrRegister } from "customHooks/useCompleoReactHookForm/helpers/reactHookFormsHelper";
import _ from "lodash";
import { useApproverCustomList } from "./useApproversCustomList";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialog: {
            backgroundColor: "#f4f6f8"
        }
    })
);

interface IProps {
    modalData: ModalDataType;
    handleModalClose: any;
    t: TFunction;
    mainFieldName: string;
    setFieldValue: (value: any) => void;
    metadata: ApiStateType;
    i18n: i18n;
    readyTranslation: boolean;
    stageIdsWithApprovers?: string[];
}

const StageActionsModal = (props: IProps) => {
    const {
        handleModalClose,
        modalData,
        t,
        mainFieldName,
        setFieldValue,
        metadata,
        i18n,
        readyTranslation,
        stageIdsWithApprovers = []
    } = props;
    const classes = useStyles();

    const { watch } = useRhfFieldWithoutControllerOrRegister(mainFieldName);
    const [lists, readyCustomList] = useApproverCustomList(t);

    const initialValues: Compleo.IObject = {
        ...(modalData.stage || {})
    };
    const [valuesFromSource] = useValuesFromSource(
        metadata,
        true,
        initialValues
    );

    const closeModal = () => {
        handleModalClose();
    };

    let addStageReturn: ApiStateType = {
        status: "success",
        response: {},
        exception: null
    };

    const addStage = async (values: any) => {
        let retorno: { [k: string]: any } = {};
        retorno = { status: 200 };
        const fieldValue = watch(mainFieldName);

        const currentField = [...fieldValue];

        if (modalData.new) {
            const newId = util.uuid();
            currentField.splice(modalData.index, 0, { ...values, id: newId });
            const reorderedStages = currentField.map(
                (item: any, index: any) => {
                    return {
                        ...item,
                        order: index
                    };
                }
            );
            setFieldValue(reorderedStages);
        } else {
            currentField[modalData.index] = {
                ...currentField[modalData.index],
                ...values
            };
            setFieldValue(currentField);
        }

        handleModalClose();
        return retorno;
    };

    const initialValuesReady =
        (!modalData.new && !_.isEmpty(initialValues.name)) || modalData.new;

    const ready =
        metadata.status === "success" && readyTranslation && initialValuesReady;

    const addProps = [
        {
            fieldName: "approvers",
            props: {
                stageIndex: modalData.index,
                mainFieldName: mainFieldName
            }
        }
    ];

    const [formCompleo, finished, handleSubmit] = useCompleoReactHookForm({
        FormType: FormModal,
        t: t,
        i18nV: i18n,
        ready: ready,
        postMethod: addStage,
        postReturn: addStageReturn,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource,
        customLists: lists,
        additionalFieldProperties: addProps
    });

    const handleSave = async () => {
        handleSubmit();
    };

    let compRetorno: boolean | JSX.Element = <Loading />;

    if (finished && readyTranslation) {
        compRetorno = formCompleo;
    }

    return (
        <Dialog
            open={modalData.open}
            onClose={handleModalClose}
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="lg"
            fullWidth
            aria-labelledby={t("a_ModalTitle")}
            aria-describedby={t("a_ModalTitle")}
            PaperProps={{
                className: classes.dialog
            }}
            scroll="body"
        >
            <DialogTitle id="alert-dialog-title">
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        {t("a_ModalTitle")}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>{compRetorno}</DialogContent>
            <DialogActions>
                <Button
                    type="button"
                    onClick={() => closeModal()}
                    color="secondary"
                    disabled={!finished}
                >
                    {t("COMPLEOGENERAL_CANCEL")}
                </Button>
                <Button
                    onClick={() => handleSave()}
                    variant="contained"
                    color="primary"
                    disabled={!finished}
                >
                    {t("COMPLEOGENERAL_SAVE")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StageActionsModal;
